module.exports = __webpack_public_path__ + "img/escudo-universidad-de-guanajuato.6c5cf13f.jpg";